import axios from "axios"
import requests from "/src/utils/requests"

const sendSms = data => requests({
	url: "/client/v1/auth/sms/send",
	method: "post",
	data
})

const phoneLogin = data => requests({
	url: "/client/v1/auth/login",
	method: "post",
	data
})

const createQrLogin = () => requests({
	url: "/client/v1/auth/qr/create",
	method: "get"
})

const getQrLoginStatus = params => requests({
	url: "/client/v1/auth/qr/status",
	method: "get",
	params
})

const logout = () => requests({
	url: "/client/v1/auth/logout",
	method: "get"
})

const createShareRecord = data => requests({
	url: "/client/v1/shareRecord/create",
	method: "post",
	data
})

const getShareRecordList = params => requests({
	url: "/client/v1/shareRecord/list",
	method: "get",
	params
})

const generateShareRecordPreview = data => requests({
	url: "/client/v1/shareRecord/generatePreview",
	method: "post",
	data
})

const deleteShareRecord = data => requests({
	url: "/client/v1/shareRecord/delete",
	method: "post",
	data
})

const setShareRecordExpireTime = data => requests({
	url: "/client/v1/shareRecord/setExpireTime",
	method: "post",
	data
})

const setShareRecordStatus = data => requests({
	url: "/client/v1/shareRecord/setStatus",
	method: "post",
	data
})

const getUserInfo = () => requests({
	url: "/client/v1/user/getUserInfo",
	method: "get"
})

const setUserAvatar = data => requests({
	url: "/client/v1/user/setUserAvatar",
	method: "post",
	data
})

const getRealnameAuthStatus = () => requests({
	url: "/client/v1/user/getRealnameAuthStatus",
	method: "get"
})

const getAuthInfo = () => requests({
	url: "/client/v1/user/getAuthInfo",
	method: "get"
})

const setAuthInfo = data => requests({
	url: "/client/v1/user/setAuthInfo",
	method: "post",
	data
})

const getSharebeanBalance = () => requests({
	url: "/client/v1/user/getSharebeanBalance",
	method: "get"
})

const getSharebeanRecords = params => requests({
	url: "/client/v1/user/getSharebeanRecordList",
	method: "get",
	params
})

const getAiHelperInfo = () => requests({
	url: "/client/v1/user/getAiHelperInfo",
	method: "get"
})

const openAiHelper = data => requests({
	url: "/client/v1/user/openAiHelper",
	method: "post",
	data
})

const getAiHelperOrderList = params => requests({
	url: "/client/v1/user/getAiHelperOrderList",
	method: "get",
	params
})

const createInvitationCode = () => requests({
	url: "/client/v1/user/createInvitationCode",
	method: "post"
})

const getInvitationRecordList = params => requests({
	url: "/client/v1/user/getInvitationRecordList",
	method: "get",
	params
})

const getPublicConfig = params => requests({
	url: "/mini/v1/config/getByType",
	method: "get",
	params
})

const addFeedback = data => requests({
	url: "/client/v1/feedback/add",
	method: "post",
	data
})

const getFeedbackList = params => requests({
	url: "/client/v1/feedback/list",
	method: "get",
	params
})

const getSharebeanPackages = () => requests({
	url: "/client/v1/sharebean/package/list",
	method: "get"
})

const getSharebeanRechargeQr = params => requests({
	url: "/client/v1/sharebean/package/rechargeQr",
	method: "get",
	params
})

const buySharebeanPackage = data => requests({
	url: "/client/v1/sharebean/package/buy",
	method: "post",
	data
})

const confirmSharebeanPackagePay = data => requests({
	url: "/client/v1/sharebean/package/pay/confirm",
	method: "post",
	data
})

const getResumeBaseInfo = () => requests({
	url: "/client/v1/resumeBase/getResumeBaseInfo",
	method: "get"
})

const getQiniuUploadToken = data => requests({
	url: "/client/v1/common/qiniu/token",
	method: "post",
	data
})

const uploadToQiniu = ({ file, token, key }) => {
	const formData = new FormData()
	formData.append("file", file)
	formData.append("token", token)
	formData.append("key", key)
	return axios.post("https://up-z0.qiniup.com", formData, {
		headers: {
			"Content-Type": "multipart/form-data"
		}
	}).then(res => res.data)
}

const saveResumeBaseInfo = data => requests({
	url: "/client/v1/resumeBase/setResumeBaseInfo",
	method: "post",
	data
})

const getResumeList = params => requests({
	url: "/client/v1/resume/getResumeList",
	method: "get",
	params
})

const getResumeTemplateList = () => requests({
	url: "/client/v1/resume/getResumeTemplateList",
	method: "get"
})

const getReviewRecordList = params => requests({
	url: "/client/v1/resume/getReviewRecordList",
	method: "get",
	params
})

const getResume = params => requests({
	url: "/client/v1/resume/getResume",
	method: "get",
	params
})

const getResumeTypeList = () => requests({
	url: "/client/v1/resume/type/list",
	method: "get"
})

const createResumeType = data => requests({
	url: "/client/v1/resume/type/add",
	method: "post",
	data
})

const deleteResumeType = data => requests({
	url: "/client/v1/resume/type/delete",
	method: "post",
	data
})

const saveResume = data => requests({
	url: "/client/v1/resume/setResume",
	method: "post",
	data
})

const applyResumeTemplate = data => requests({
	url: "/client/v1/resume/applyResumeTemplate",
	method: "post",
	data
})

const saveResumeContent = data => requests({
	url: "/client/v1/resume/saveContent",
	method: "post",
	data
})

const deleteResume = data => requests({
	url: "/client/v1/resume/deleteResume",
	method: "post",
	data
})

const publishResume = data => requests({
	url: "/client/v1/resume/publishResume",
	method: "post",
	data
})

const saveIntroduce = data => requests({
	url: "/client/v1/resume/setResumeIntroduce",
	method: "post",
	data
})

const saveWorkExp = data => requests({
	url: "/client/v1/resumeWorkExp/setResumeWorkExp",
	method: "post",
	data
})

const deleteWorkExp = data => requests({
	url: "/client/v1/resumeWorkExp/deleteResumeWorkExp",
	method: "post",
	data
})

const saveProjectExp = data => requests({
	url: "/client/v1/resumeProjectExp/setResumeProjectExp",
	method: "post",
	data
})

const deleteProjectExp = data => requests({
	url: "/client/v1/resumeProjectExp/deleteResumeProjectExp",
	method: "post",
	data
})

const saveEducation = data => requests({
	url: "/client/v1/resumeEducation/setResumeEducation",
	method: "post",
	data
})

const deleteEducation = data => requests({
	url: "/client/v1/resumeEducation/deleteResumeEducation",
	method: "post",
	data
})

const saveCert = data => requests({
	url: "/client/v1/resumeCert/setResumeCert",
	method: "post",
	data
})

const deleteCert = data => requests({
	url: "/client/v1/resumeCert/deleteResumeCert",
	method: "post",
	data
})

const getAiPrompts = () => requests({
	url: "/client/v1/ai/getPromptList",
	method: "get"
})

const getAiHistory = params => requests({
	url: "/client/v1/ai/getChatHistory",
	method: "get",
	params
})

const chatWithPrompt = data => requests({
	url: "/client/v1/ai/chatWithPrompt",
	method: "post",
	data
})

const recognizeResumeMaterial = data => requests({
	url: "/client/v1/ai/recognizeResumeMaterial",
	method: "post",
	data
})

const getCareerPostList = params => requests({
	url: "/client/v1/careerPost/list",
	method: "get",
	params
})

const publishCareerPost = data => requests({
	url: "/client/v1/careerPost/publish",
	method: "post",
	data
})

const toggleCareerPostLike = data => requests({
	url: "/client/v1/careerPost/toggleLike",
	method: "post",
	data
})

const toggleCareerPostFavorite = data => requests({
	url: "/client/v1/careerPost/toggleFavorite",
	method: "post",
	data
})

const rewardCareerPost = data => requests({
	url: "/client/v1/careerPost/reward",
	method: "post",
	data
})

const getCareerPostCommentList = params => requests({
	url: "/client/v1/careerPost/comment/list",
	method: "get",
	params
})

const addCareerPostComment = data => requests({
	url: "/client/v1/careerPost/comment/add",
	method: "post",
	data
})

const updateCareerPostStatus = data => requests({
	url: "/client/v1/careerPost/updateStatus",
	method: "post",
	data
})

const deleteCareerPost = data => requests({
	url: "/client/v1/careerPost/delete",
	method: "post",
	data
})

const getMyFavoriteCareerPostList = params => requests({
	url: "/client/v1/careerPost/myFavoriteList",
	method: "get",
	params
})

const getMyLikeCareerPostList = params => requests({
	url: "/client/v1/careerPost/myLikeList",
	method: "get",
	params
})

const getCareerUserHome = params => requests({
	url: "/client/v1/user/getUserHome",
	method: "get",
	params
})

const toggleCareerUserFollow = data => requests({
	url: "/client/v1/user/toggleFollow",
	method: "post",
	data
})

const getDisciplineCurrent = () => requests({
	url: "/client/v1/discipline/current",
	method: "get"
})

const createDisciplineChallenge = data => requests({
	url: "/client/v1/discipline/create",
	method: "post",
	data
})

const generateDisciplineDay = data => requests({
	url: "/client/v1/discipline/generateDay",
	method: "post",
	data
})

const submitDisciplineAnswer = data => requests({
	url: "/client/v1/discipline/submitAnswer",
	method: "post",
	data
})

const getDisciplineRank = params => requests({
	url: "/client/v1/discipline/rank",
	method: "get",
	params
})

const generateDisciplineResult = data => requests({
	url: "/client/v1/discipline/result",
	method: "post",
	data
})

export default {
	sendSms,
	phoneLogin,
	createQrLogin,
	getQrLoginStatus,
	logout,
	createShareRecord,
	getShareRecordList,
	generateShareRecordPreview,
	deleteShareRecord,
	setShareRecordExpireTime,
	setShareRecordStatus,
	getUserInfo,
	setUserAvatar,
	getRealnameAuthStatus,
	getAuthInfo,
	setAuthInfo,
	getSharebeanBalance,
	getSharebeanRecords,
	getAiHelperInfo,
	openAiHelper,
	getAiHelperOrderList,
	createInvitationCode,
	getInvitationRecordList,
	getPublicConfig,
	addFeedback,
	getFeedbackList,
	getSharebeanPackages,
	getSharebeanRechargeQr,
	buySharebeanPackage,
	confirmSharebeanPackagePay,
	getQiniuUploadToken,
	uploadToQiniu,
	getResumeBaseInfo,
	saveResumeBaseInfo,
	getResumeList,
	getResumeTemplateList,
	getReviewRecordList,
	getResume,
	getResumeTypeList,
	createResumeType,
	deleteResumeType,
	saveResume,
	applyResumeTemplate,
	saveResumeContent,
	deleteResume,
	publishResume,
	saveIntroduce,
	saveWorkExp,
	deleteWorkExp,
	saveProjectExp,
	deleteProjectExp,
	saveEducation,
	deleteEducation,
	saveCert,
	deleteCert,
	getAiPrompts,
	getAiHistory,
	chatWithPrompt,
	recognizeResumeMaterial,
	getCareerPostList,
	publishCareerPost,
	toggleCareerPostLike,
	toggleCareerPostFavorite,
	rewardCareerPost,
	getCareerPostCommentList,
	addCareerPostComment,
	updateCareerPostStatus,
	deleteCareerPost,
	getMyFavoriteCareerPostList,
	getMyLikeCareerPostList,
	getCareerUserHome,
	toggleCareerUserFollow,
	getDisciplineCurrent,
	createDisciplineChallenge,
	generateDisciplineDay,
	submitDisciplineAnswer,
	getDisciplineRank,
	generateDisciplineResult
}
